import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';
import { facilityGroupsKey } from '@services/useFacilityGroupsQuery';

const facilityGroupDeleteFn = ({ group_id }: { group_id: number }) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/facility-location-group/${group_id}`);

export const useFacilityGroupDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: facilityGroupDeleteFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [facilityGroupsKey()][0] });
    },
  });
};
